module.exports = __webpack_public_path__ + "img/Monki-logo.f0d31daf.png";